import type { SRT_RowData, SRT_TableInstance } from '../../types'

import React, { useMemo } from 'react'

import { TableHeader } from '@/shared/components/ui/table'

import { getHeaders } from '../../utils/utils'
import { SRT_TableHeadRow } from './SRT_TableHeadRow'

export function SRT_TableHead<T extends SRT_RowData>({
	table,
}: {
	table: SRT_TableInstance<T>
}) {
	const leafHeaders = table.getLeafHeaders()
	const headers = useMemo(() => getHeaders(table), [leafHeaders])

	return (
		<TableHeader>
			{headers.map((headers, i) => (
				<SRT_TableHeadRow key={i} headers={headers} table={table} />
			))}
		</TableHeader>
	)
}
